import { isWebViewReact } from "@/apollo/reactives";
import { Button } from "@/components/Buttons";
import { TextField } from "@/components/Form/Parts/index";
import { useDeviceInfoQuery } from "@/hooks";
import formStyles from "@/styles/Form.module.scss";
import passwordResetStyles from "@/styles/PasswordReset.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as y from "yup";

const schema = y.object().shape({
  mailAddress: y
    .string()
    .email("メールアドレスの形式で入力してください。")
    .required("メールアドレスが入力されていません。"),
});
export default function PasswordResetMailAddressForm({ onSubmit, handleBack }) {
  const { formState, register, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
  });
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });
  const isWebView = isWebViewReact();

  const { isDirty, isValid, isSubmitting, errors } = formState;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={processStyles.contentWrapper}>
        <div className={processStyles.content}>
          <p>
            登録しているEメールアドレス（ログインID）をご入力ください。
            <br />
            新しいパスワードを設定するためのリンクをお送りします。
          </p>
          <fieldset className={formStyles.basicFieldset}>
            <TextField
              {...register("mailAddress")}
              title="Eメールアドレス（ログインID）"
              type="email"
              placeholder="半角英数字でご利用中のメールアドレスを入力"
              caption={
                "「@skyperfectv.co.jp」からのメールを受信できる様、ドメイン設定を解除して頂いただくか、又は弊社ドメイン『skyperfectv.co.jp』を 受信リストに加えていただきますよう、お願い申し上げます"
              }
              error={errors.mailAddress?.message}
              required
            />
          </fieldset>
        </div>
      </div>
      <div
        className={`${formStyles.btnArea} ${formStyles.multiple} ${passwordResetStyles.btnArea}`}
      >
        {!isWebView && (
          <Button
            type="button"
            fillGray
            borderGray
            fontFixed
            onClick={handleBack}
          >
            キャンセル
          </Button>
        )}
        <Button
          type="submit"
          fillColor
          fontFixed
          disabled={!isDirty || !isValid}
          loading={isSubmitting}
        >
          送信
        </Button>
      </div>
    </form>
  );
}
